import React from 'react';

/*
 * The bulk bar sits after the list and pager (sticky at the bottom), so keyboard users get a
 * "Go to bulk actions" button (shown on focus) and a polite "N selected" announcement.
 */
const BulkSkip = ({ count, target_id }) => (
  <>
    <div className="sr-only" role="status" aria-live="polite">
      {count ? `${count} selected` : ''}
    </div>
    {count ? (
      <button
        type="button"
        className="tp-link tp-skip-bulk sr-only"
        onClick={() => {
          const bar = document.getElementById(target_id);
          if (bar) bar.focus();
        }}
      >
        Go to bulk actions
      </button>
    ) : null}
  </>
);

export default BulkSkip;
